import React from 'react';
import firebase from '../../firebase';
import md5 from 'md5';
import { Grid, Form, Header, Button, Message, Segment, Image } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import logo from '../../assets/pulse_logo.png'

class SignUp extends React.Component {

  state = {
    username: "",
    email: "",
    password: "",
		confirmPassword: "",
		errors: [],
		loading: false,
		usersRef: firebase.database().ref('users')
	};
	
	isFormValid = () => {

		let errors = [];
		let error;

		if(this.isFormEmpty(this.state)) {
			error = { message: 'Please fill all fields' };
			this.setState({ errors: errors.concat(error) })
			return false;
		} else if(!this.isPasswordValid(this.state)) {
			error = { message: 'Password is invalid! Must be minimum 8 characters' };
      this.setState({ errors: errors.concat(error) });
      return false;
		} else {
			return true;
		}
	}

	isFormEmpty = ({ username, email, password, confirmPassword }) => {
		return !username.length || !email.length || !password.length || !confirmPassword.length;
	}

	isPasswordValid = ({ password, confirmPassword }) => {

		if(password.length < 8 || confirmPassword.length < 8) {
			return false;
		} else if (password !== confirmPassword){
			return false;
		} else {
			return true;
		}
	}
		
	displayErrors = errors => 
		errors.map( (error, i) => <p key={i}> {error.message} </p> );

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = event => {

		event.preventDefault();

		if (this.isFormValid()) {
			this.setState({ errors: [], loading: true });
			
			firebase
				.auth()
				.createUserWithEmailAndPassword(this.state.email, this.state.password)
				.then(createdUser => {
					console.log(createdUser);
					createdUser.user.updateProfile({
						displayName: this.state.username,
						photoURL: `http://gravatar.com/avatar/${md5(createdUser.user.email)}?d=identicon`
					})
					.then(() => {
						this.saveUser(createdUser).then( () => {
							console.log('user saved');
						})
					})
					.catch(err => {
						console.error(err);
						this.setState({ errors: this.state.errors.concat(err), loading: false });
					})
				})
				.catch(err => {
					console.error(err);
					this.setState({ errors: this.state.errors.concat(err), loading: false });
				});
		}
	};
	
	saveUser = createdUser => {
		return this.state.usersRef.child(createdUser.user.uid).set({
			name: createdUser.user.displayName,
			avatar: createdUser.user.photoURL
		});
	}

	handleInputError = (errors, inputName) => {
		return errors.some(error => error.message.toLowerCase().includes(inputName)) ? 'error' : '' 
	}

  render() {
    const { username, email, password, confirmPassword, errors, loading } = this.state;

    return (

      <Grid textAlign="center" verticalAlign="middle" className="main">
        <Grid.Column style={{ maxWidth: 500 }}>
          <Header inverted as="h1" textAlign="center" color='teal'>
              PULSE
          </Header>
          <Header inverted as="h4" textAlign="center" color='teal'>
            A ChatApp For Developers 
          </Header>
          <Image src={logo} centered size='medium'/>
          <Header inverted as="h1" textAlign="center" color='teal'>
            SIGN UP
          </Header>
          <Form inverted onSubmit={this.handleSubmit} size="large">
            <Segment inverted stacked>
              <Form.Input fluid name="username" icon="user" iconPosition="left" placeholder="Username"
								onChange={this.handleChange} value={username} type="text" />
              <Form.Input fluid name="email" icon="mail" iconPosition="left" placeholder="Email Address"
                onChange={this.handleChange} value={email} 
								className={this.handleInputError(errors, 'email')} type="email" />
              <Form.Input fluid name="password" icon="lock" iconPosition="left" placeholder="Enter Password upto 8 characters"
  							onChange={this.handleChange} value={password} 
								className={this.handleInputError(errors, 'password')} type="password" />
              <Form.Input fluid name="confirmPassword" icon="repeat" iconPosition="left" placeholder="Confirm Password"
                onChange={this.handleChange} value={confirmPassword}
								className={this.handleInputError(errors, 'password')} type="password" />
              <Button disabled={loading} className={loading ? 'loading' : ''} fluid size="large">
                Sign Up
              </Button>
            </Segment>
          </Form>
					{errors.length > 0 && (
						<Message error>
							<h3>Error!</h3>
							{this.displayErrors(errors)}
						</Message>
					)}
          <Message>
            Already a user? <Link to="/login"> Login </Link>
          </Message>
        </Grid.Column>
      </Grid>
    );
  }
}

export default SignUp;